<div class="flex flex-col">
  <ng-container>
    <div class="flex align-middle flex-wrap">
      <h2>{{ 'settings.general.maxSlippage' | translate }}</h2>
      <common-info-toggle
        [infoText]="'settings.general.maxSlippageInfo' | translate"
      ></common-info-toggle>
    </div>
    <div class="flex py-2">
      <div class="flex mr-2 items-center">
        <input
          (input)="updateIsValid()"
          [(ngModel)]="maxSlippageInPercent"
          [value]="maxSlippageInPercent"
          id="maxSlippage"
          type="number"
          max="100"
          min="0"
          class="w-20 px-2 py-1 rounded-lg h-8 border mr-1{{
            maxSlippageInvalid ? 'border-orange' : null
          }}"
        /><span>%</span>
      </div>
      <button
        (click)="maxSlippage = 0.001; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-2 {{
          maxSlippage === 0.001 ? '!bg-green' : 'border'
        }}"
      >
        0.1%
      </button>
      <button
        (click)="maxSlippage = 0.005; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-2 {{
          maxSlippage === 0.005 ? '!bg-green' : 'border'
        }}"
      >
        0.5%
      </button>
      <button
        (click)="maxSlippage = 0.01; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          maxSlippage === 0.01 ? '!bg-green' : 'border'
        }}"
      >
        1%
      </button>
    </div>
  </ng-container>
  <ng-container>
    <div class="mt-2 flex align-middle flex-wrap">
      <h2>{{ 'settings.general.maxPriceImpact' | translate }}</h2>
      <common-info-toggle
        [infoText]="'settings.general.maxPriceImpactInfo' | translate"
      ></common-info-toggle>
    </div>
    <div class="flex py-2">
      <div class="flex mr-2 items-center">
        <input
          (input)="updateIsValid()"
          [(ngModel)]="maxPriceImpactInPercent"
          [value]="maxPriceImpactInPercent"
          id="maxPriceImpact"
          type="number"
          max="100"
          min="0"
          class="w-20 px-2 py-1 rounded-lg h-8 border mr-1{{
            maxPriceImpactInvalid ? 'border-orange' : null
          }}"
        /><span>%</span>
      </div>
      <button
        (click)="maxPriceImpact = 0.003; updateIsValid()"
        class="button-transparent hover:!green button-sm mr-2 {{
          maxPriceImpact === 0.003 ? '!bg-green' : 'border'
        }}"
      >
        0.3%
      </button>
      <button
        (click)="maxPriceImpact = 0.01; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          maxPriceImpact === 0.01 ? '!bg-green' : 'border'
        }}"
      >
        1%
      </button>
      <button
        (click)="maxPriceImpact = 0.03; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          maxPriceImpact === 0.03 ? '!bg-green' : 'border'
        }}"
      >
        3%
      </button>
    </div>
  </ng-container>
  <ng-container>
    <div class="mt-2 flex align-middle flex-wrap">
      <h2>{{ 'settings.general.minExpirySec' | translate }}</h2>
      <common-info-toggle
        [infoText]="'settings.general.minExpirySecInfo' | translate"
      ></common-info-toggle>
    </div>
    <div class="flex py-2">
      <div class="flex mr-2 items-center">
        <input
          (input)="updateIsValid()"
          [(ngModel)]="minExpirySec"
          [value]="minExpirySec"
          id="minExpirySec"
          type="number"
          max="120"
          min="0"
          class="w-20 px-2 py-1 rounded-lg h-8 border mr-1{{
            minExpirySecInvalid ? 'border-orange' : null
          }}"
        /><span class="ml-1">sec</span>
      </div>
      <button
        (click)="minExpirySec = 35; updateIsValid()"
        class="button-transparent hover:!green button-sm mr-2 {{
          minExpirySec === 35 ? '!bg-green' : 'border'
        }}"
      >
        35 sec
      </button>
      <button
        (click)="minExpirySec = 55; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          minExpirySec === 55 ? '!bg-green' : 'border'
        }}"
      >
        55 sec
      </button>
      <button
        (click)="minExpirySec = 85; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          minExpirySec === 85 ? '!bg-green' : 'border'
        }}"
      >
        85 sec
      </button>
    </div>
  </ng-container>
  <ng-container>
    <div class="mt-2 flex align-middle flex-wrap">
      <h2>{{ 'settings.general.minTradeValue' | translate }}</h2>
      <common-info-toggle
        [infoText]="'settings.general.minTradeValueInfo' | translate"
      ></common-info-toggle>
    </div>
    <div class="flex py-2">
      <div class="flex mr-2 items-center">
        <input
          (input)="updateIsValid()"
          [(ngModel)]="minTradeValue"
          [value]="minTradeValue"
          id="minTradeValue"
          type="number"
          min="0"
          class="w-20 px-2 py-1 rounded-lg h-8 border mr-1{{
            minExpirySecInvalid ? 'border-orange' : null
          }}"
        /><span class="ml-1">$</span>
      </div>
      <button
        (click)="minTradeValue = 1; updateIsValid()"
        class="button-transparent hover:!green button-sm mr-2 {{
          minTradeValue === 1 ? '!bg-green' : 'border'
        }}"
      >
        {{ 1 | currency }}
      </button>
      <button
        (click)="minTradeValue = 10; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          minTradeValue === 10 ? '!bg-green' : 'border'
        }}"
      >
        {{ 10 | currency }}
      </button>
      <button
        (click)="minTradeValue = 100; updateIsValid()"
        class="button-transparent hover:!bg-green button-sm mr-4 {{
          minTradeValue === 100 ? '!bg-green' : 'border'
        }}"
      >
        {{ 100 | currency }}
      </button>
    </div>
  </ng-container>
  <!--  <div class="border-b border-dashed pt-1 mb-1"></div>-->
  <!--  <ng-container *ngIf="batchTradeSupported">-->
  <!--    <div class="py-2">-->
  <!--      <common-toggle-input-->
  <!--        [value]="batchTrade"-->
  <!--        [label]="'settings.experimental.batchTrade' | translate"-->
  <!--        [infoText]="'settings.experimental.batchTradeInfo' | translate"-->
  <!--        (valueChanged)="batchTrade = $event; updateIsValid()"-->
  <!--      ></common-toggle-input>-->
  <!--    </div>-->
  <!--    <div *ngIf="batchTrade" class="py-2">-->
  <!--      <common-toggle-input-->
  <!--        [value]="revertOnError"-->
  <!--        [label]="'settings.experimental.revertOnError' | translate"-->
  <!--        [infoText]="'settings.experimental.revertOnErrorInfo' | translate"-->
  <!--        (valueChanged)="revertOnError = $event; updateIsValid()"-->
  <!--      ></common-toggle-input>-->
  <!--    </div>-->
  <!--    <div class="border-b border-dashed pt-1 mb-1"></div>-->
  <!--  </ng-container>-->
  <!--  <div class="py-2">-->
  <!--    <common-toggle-input-->
  <!--      [value]="rfqtEnabled"-->
  <!--      [label]="'settings.general.rfqtEnabled' | translate"-->
  <!--      [infoText]="'settings.general.rfqtEnabledInfo' | translate"-->
  <!--      (valueChanged)="rfqtEnabled = $event; updateIsValid()"-->
  <!--    ></common-toggle-input>-->
  <!--  </div>-->
  <!--  <div class="border-b border-dashed pt-1 mb-1"></div>-->
  <!--  <div class="py-2">-->
  <!--    <common-toggle-input-->
  <!--      [value]="automatedMarketMakerEnabled"-->
  <!--      [label]="'settings.general.automatedMarketMakerEnabled' | translate"-->
  <!--      [infoText]="-->
  <!--        'settings.general.automatedMarketMakerEnabledInfo' | translate-->
  <!--      "-->
  <!--      (valueChanged)="automatedMarketMakerEnabled = $event; updateIsValid()"-->
  <!--    ></common-toggle-input>-->
  <!--  </div>-->
</div>
